module.exports = __webpack_public_path__ + "img/user-active.abd79988.svg";